import styled from 'styled-components';

/* istanbul ignore next */
export const TaxOverrideFieldInputContainer = styled.div<any>`
    width: 8rem;

    & .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-adornedStart.MuiInputBase-adornedEnd:before {
        content: '';
        display: ${({ $taxOverrideFormEdited }) => ($taxOverrideFormEdited ? 'block' : 'none')};
        height: 100%;
        width: 0.375rem;
        background: #ebb000;
        position: absolute;
        left: 0;
        top: 0;
        border-top-left-radius: inherit;
        border-bottom-left-radius: inherit;
    }
`;
